<template>
  <div class="t-confirm">
    <transition name="fade">
      <div class="modal" v-if="show"></div>
    </transition>
    <transition name="dialog">
      <div class="confirm-box centerF" v-if="show">
        <!-- 标题部分 -->
        <div class="confirm-hd">
          <h1>{{option.title}}</h1>
        </div>
        <!-- 内容部分 -->
        <div class="confirm-bd">
          <p>{{option.content}}</p>
          <input v-focus v-if="option.type==='input'" v-model="value" type="text" :placeholder="option.placeholder">
        </div>
        <!-- 按钮组 -->
        <div class="ub">
          <div class="ub-f1" v-if="option.type!=='alert'">
            <p @click="cancel()">取消</p>
          </div>
          <div class="ub-f1">
            <p class="ok" @click="ok()">确定</p>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
/**
   * @param title 提示文字
   * @param content 提示文字
   * @param type 弹窗类型包含:默认,alert,input
   * @param placeholder 当为input类型有效
   * @param cb 回调方法,第一个参数为布尔值选中确认/取消，第二个为关闭弹窗方法done(), 第三个为input类型时的输入值
   * @describe 此组件为js调用组件详细见common调用方法,
   *
   * @example
   *
    this.$confirm( '确定删除吗？', (data, done) => { if(data){ done(); alert('成功！')} });
   */
export default {
  name: 'tConfirm',
  data() {
    return {
      show: false,
      value: '',
      option: {
        type: '',
        title: '提示',
        content: '',
        placeholder: '',
      },
    };
  },
  mounted: function () {
    this.show = true;
  },
  methods: {
    done: function () {
      this.show = false;
    },
  },
};

</script>
<style lang="scss">
@import "../style/mixin";


/*确认弹窗样式*/

.confirm-box {
  z-index: 20;
  background-color: #fff;
  width: 80%;
  max-width: 3rem;
  border-radius: 3px;
  overflow: hidden;
  .ub {
    @include border-1px-t(#D5D5D6);
  }
  .ub-f1 {
    p {
      height: 0.48rem;
      line-height: 0.48rem;
      text-align: center;
      font-size: 0.17rem;
      color: #2D2D2D;
    }
    p.ok {
      color: #E24817;
      @include border-1px-l(#D5D5D6);
    }
  }
}

.confirm-hd {
  padding: 0.18rem 0.2rem 0.1rem;
  h1 {
    font-weight: 400;
    font-size: 0.18rem;
    text-align: center;
  }
}

.confirm-bd {
  padding: 0.08rem 0.2rem 0.23rem;
  min-height: 0.52rem;
  font-size: 0.15rem;
  line-height: 0.2rem;
  word-wrap: break-word;
  word-break: break-all;
  color: #999999;
  p {
    text-align: center;
  }
  input {
    width: 100%;
    border: 1px solid #dedede;
    border-radius: 5px;
    padding: 0.06rem;
    -webkit-appearance: none;
    appearance: none;
    outline: none;
    font-size: 0.15rem;
    line-height: 0.2rem;
    color: #333;
  }
}

.confirm-img {
  text-align: center;
  padding-top: 0.26rem;
  padding-bottom: 0.14rem;
  img {
    display: inline-block;
    width: 1.53rem;
  }
  p {
    margin-top: 0.14rem;
    line-height: 0.2rem;
    min-height: 0.24rem;
    color: #2d2d2d;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/confirm.vue